// Calories, macros and steps as the recipe pages and structured data show them. Macros and step
// timers are additive backend fields (recipe response v3): older recipes carry neither, so
// every reader here treats them as optional and returns nothing rather than a placeholder.
import { toLatinDigits, toPersianDigits } from './recipeTime.js';

const MACROS = [
    { key: 'proteinGrams', label: 'پروتئین', schemaProperty: 'proteinContent' },
    { key: 'fatGrams', label: 'چربی', schemaProperty: 'fatContent' },
    { key: 'carbsGrams', label: 'کربوهیدرات', schemaProperty: 'carbohydrateContent' },
];

const MAX_TIMER_MINUTES = 600;

const toWholeNumber = (value) => {
    if (typeof value !== 'number' && typeof value !== 'string') return null;
    const text = toLatinDigits(value).trim();
    if (!text) return null;
    const number = Number(text);
    return Number.isFinite(number) && number >= 0 ? Math.round(number) : null;
};

export const caloriesPerServing = (recipe) => {
    const calories = parseInt(toLatinDigits(recipe?.estimatedCaloriesPerServing), 10);
    return calories > 0 ? calories : 0;
};

// [{ key, label, schemaProperty, grams }] in protein, fat, carbs order; empty when absent.
export const recipeMacros = (recipe) => {
    const macros = recipe?.macrosPerServing;
    if (!macros || typeof macros !== 'object') return [];
    return MACROS
        .map((macro) => ({ ...macro, grams: toWholeNumber(macros[macro.key]) }))
        .filter((macro) => macro.grams !== null);
};

export const formatGramsFa = (grams) => `${toPersianDigits(grams)} گرم`;

// A step timer is 1–600 whole minutes; anything else means the step has no timer.
export const stepTimerMinutes = (step) => {
    const minutes = toWholeNumber(step?.timerMinutes);
    return minutes >= 1 && minutes <= MAX_TIMER_MINUTES ? minutes : 0;
};

// [{ text, timerMinutes }] from structured steps, or from the legacy flat instructions.
export const recipeSteps = (recipe) => (recipe?.steps?.length
    ? recipe.steps.map((step) => ({ text: step?.text || '', timerMinutes: stepTimerMinutes(step) }))
    : (recipe?.instructions || '').split('\n').filter(Boolean).map((text) => ({ text, timerMinutes: 0 })));
